// src/components/post/Posts.jsx
import React, { useEffect, useState } from "react";
import PostItem from "./PostItem";
import Loader from '../common/Loader';
import axios from 'axios';

const Posts = () => {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/posts`);
        // Make sure we're setting an array, even if the API returns something else
        if (Array.isArray(response?.data)) {
          setPosts(response.data);
        } else if (response?.data?.posts && Array.isArray(response.data.posts)) {
          // In case API returns { posts: [...] } format
          setPosts(response.data.posts);
        } else {
          // If we can't find an array, set empty array and show error
          setPosts([]);
          setError("Received invalid data format from server");
          console.error("API response is not an array:", response?.data);
        }
      } catch (err) {
        console.error("Error fetching posts:", err);
        setError("Failed to load posts. Please try again later.");
        setPosts([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPosts();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-[300px] flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative mt-6" role="alert">
        <span className="block sm:inline">{error}</span>
      </div>
    );
  }

  if (!posts || posts.length === 0) {
    return (
      <div className="text-center py-12">
        <h2 className="text-2xl font-bold text-gray-700">No Posts Found!</h2>
        <p className="text-gray-500 mt-2">Check back later for new content</p>
      </div>
    );
  }

  return (
    <section className="py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {posts.map(({_id: id, thumbnail, category, title, description, creator, createdAt }) => (
            <PostItem
              key={id}
              postID={id}
              thumbnail={thumbnail}
              category={category}
              title={title}
              description={description}
              authorID={typeof creator === 'object' ? creator._id : creator}
              createdAt={createdAt}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Posts;